import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { filterOperatorServiceList, getListResult } from "../../../utils";
import { AgencyListPayload } from "../../../models/ProviderMaterials";
import AgencyDetails from "../components/AgencyDetails";
import { getMasterServiceProvider, getSendCommunicationAuthType } from "../../../actions/Master";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import { TabData } from "../../../models/TabSessionStorage";

const mapStateToProps = ({
    loggedInUserState,
    masterServiceProviderState,
    masterSendCommunicationAuthTypeState,
    benefitPlanUidState,
    tabSessionStorageState,
}: ApplicationState) => ({
    loggedInUser: loggedInUserState.response,
    masterServiceProviderState: getListResult(filterOperatorServiceList(masterServiceProviderState.response, true, loggedInUserState.response)),
    serviceProviderListWithDetails: masterServiceProviderState.response,
    masterSendCommunicationAuthTypeState: getListResult(masterSendCommunicationAuthTypeState.response),
    benefitPlanUidState: benefitPlanUidState.response,
    TabSessionStorage: tabSessionStorageState,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
        resetStates: (actionType: string, field?: string) => {
            dispatch(resetStates(actionType, field));
        },
        getMasterServiceProvider: (payload: AgencyListPayload) => {
            dispatch(getMasterServiceProvider(payload));
        },
        getSendCommunicationAuthType: () => {
            dispatch(getSendCommunicationAuthType());
        },
        saveTabSessionStorage: (sessionData: TabData) => {
            dispatch(saveTabSessionStorageResp(sessionData));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyDetails);